export default "__VITE_ASSET__m2Sf72vW__"